import TwoPartsInfoBoxesSection from 'components/two-parts-info-boxes-section'
import {identityManagementData} from 'content/home-page'
import React from 'react'

export default function IdentityManagement() {
  return (
    <TwoPartsInfoBoxesSection
      data={identityManagementData}
      mainFlexDirection="row-reverse"
      sectionBgColor="white"
      showSeparator={false}
    />
  )
}
